'use client';

import { usePathname } from "next/navigation";
import Script from "next/script";
import React, { useLayoutEffect } from "react"

function TextMeApp() {

  useLayoutEffect(() => {
    document.querySelector('#text-button')?.addEventListener('click', () => {
      if(!!window.showModal) {
        window.showModal?.()
      }
    })

    return () => {
      document.querySelector('#text-button')?.removeEventListener('click', () => {})
    }
  }, []);

  // return null;
  const pathname = usePathname()
  return (
    <Script key={pathname} src="https://cdn-public-0.s3.amazonaws.com/scripts/minified.js" strategy="afterInteractive"/>
  )
}

export default TextMeApp